import { useQuery } from '@tanstack/react-query'
import { actionPlanPaginatedListSchema, TActionPlanQuery } from '@valuecase/common'
import { useSpacesApi } from '../../../spaces-api'

export const useActionPlans = ({
  page,
  itemsPerPage,
  spaceIds,
  spaceCreatedAfter,
  spaceUpdatedAfter,
  enabled,
  skipOwnerFilter,
}: TActionPlanQuery & { enabled?: boolean; skipOwnerFilter?: boolean }) => {
  const { spacesApi } = useSpacesApi()

  return useQuery({
    queryKey: [
      'actionPlans',
      page,
      itemsPerPage,
      spaceIds,
      spaceCreatedAfter,
      spaceUpdatedAfter,
      skipOwnerFilter,
    ],
    enabled,
    queryFn: async () => {
      const urlParams = new URLSearchParams()
      if (page) {
        urlParams.append('page', page.toString())
      }
      if (itemsPerPage) {
        urlParams.append('itemsPerPage', itemsPerPage.toString())
      }
      if (spaceIds) {
        for (const spaceId of spaceIds) {
          urlParams.append('spaceIds[]', spaceId)
        }
      }
      if (spaceCreatedAfter) {
        urlParams.append('spaceCreatedAfter', spaceCreatedAfter.toISOString())
      }
      if (spaceUpdatedAfter) {
        urlParams.append('spaceUpdatedAfter', spaceUpdatedAfter.toISOString())
      }
      if (skipOwnerFilter) {
        urlParams.append('skipOwnerFilter', 'true')
      }
      const response = await spacesApi.get(`action-plans?${urlParams.toString()}`)
      return actionPlanPaginatedListSchema.parse(response.data)
    },
    staleTime: 0,
  })
}
